import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { apiUri } from "../../utilities/apiManager";

const initialState = {
  isLoading: false,
  data: [],
  itemsCount: 0,
  pages: 0,
  error: null,
};

export const getAllUsers = createAsyncThunk(
  "users/getAll",
  async (args, thunkApi) => {
    try {
      const { page = 1, size = 50, type } = args || {};
      const typeQuery = type ? `&type=${type}` : "";
      const { data } = await axios.get(
        `${apiUri}/users/all?page=${page}&size=${size}${typeQuery}`,
        {
          headers: {
            "auth-token": "Bearer " + thunkApi.getState().auth.accessToken,
            "Accept-Language": document.documentElement.lang,
          },
        }
      );
      return thunkApi.fulfillWithValue(data);
    } catch (e) {
      return thunkApi.rejectWithValue(e.response?.data || { message: "error" });
    }
  }
);

const usersAllSlice = createSlice({
  name: "usersAll",
  initialState,
  extraReducers: (b) => {
    b.addCase(getAllUsers.pending, (s) => {
      s.isLoading = true;
      s.error = null;
    })
      .addCase(getAllUsers.fulfilled, (s, { payload }) => {
        s.isLoading = false;
        s.data = payload.data?.data || [];
        s.itemsCount = Number(payload.data?.itemsCount) || 0;
        s.pages = Number(payload.data?.pages) || 0;
      })
      .addCase(getAllUsers.rejected, (s, { payload }) => {
        s.isLoading = false;
        s.error = payload?.message;
      });
  },
});

export default usersAllSlice.reducer;
